import { useRef, useState } from "react";
import { connect } from "react-redux";
import {
  LoadingIndicatorCentered,
  ResetCartIcon,
  ShowIcon,
} from "../../../../assets/icons/iconsProvider";
import {
  BG_JOB_STATUS,
  EMPTY_STRING,
  orchestratorConstants,
  shopifyConstants,
  SPINNER_MESSAGES,
  storeConstants,
  toastType,
} from "../../../../constants";
import { systemActions } from "../../../../redux/actions";
import { custom } from "../../../../redux/actions/actionsUtilities";
import ButtonWithToolTip from "../../../../shared/components/Buttons/ButtonWithToolTip";
import { customToast, isSpinnerEnabled } from "../../../../shared/utility";
import ConfirmationModal from "../../../Inventory/Items/ConfirmationModal/ConfirmationModal";

const UpdateInventoryButton = (props) => {
  const {
    currentStore,
    spinnerArray,
    storeMiscData,
    isCompanyStore,
    isResetAllowed,
    dfStartOrchestrator,
    draggableNotification,
    toggleResetStatusModal,
    isDisableResetInventory,
    setIsDisableResetInventory,
  } = props;
  const isNewResetStartedRef = useRef(false);
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  //------- non admin in company store is only disabled, running reset also shows spinner
  const isResetInventoryButtonDisabled =
    !isResetAllowed ||
    isDisableResetInventory ||
    isSpinnerEnabled(spinnerArray, storeConstants.START_ORCHESTRATOR) ||
    (Array.isArray(storeMiscData) &&
      storeMiscData.some(
        (row) =>
          row.miscData?.status !== BG_JOB_STATUS.COMPLETED &&
          row.miscData?.status !== BG_JOB_STATUS.FAILED &&
          row.miscData?.status !== BG_JOB_STATUS.TERMINATED
      ));
  const isViewResetStatusButtonDisabled =
    isResetInventoryButtonDisabled &&
    !isSpinnerEnabled(
      draggableNotification,
      SPINNER_MESSAGES.SHOPIFY_RESET_IN_PROGRESS,
      true
    ) &&
    isNewResetStartedRef.current;
  const shouldShowSpinner =
    isResetInventoryButtonDisabled &&
    Array.isArray(storeMiscData) &&
    !storeMiscData.some((row) => row.miscData?.status === BG_JOB_STATUS.PAUSED);
  // open/close confirmation modal
  const toggleConfirmationModal = () => {
    setIsConfirmationModal((prev) => !prev);
  };

  // handles clicking the "Update Inventory" button
  const handleUpdateInventoryPresetsToDefault = () => {
    toggleConfirmationModal();
  };

  // confirm button handler
  const handleConfirmYesButtonClick = async () => {
    try {
      setIsDisableResetInventory(true); // web pubsub will set it to false when the reset is completed (AppController -> onDeactivateSpinner) or if Orchestrator start fails (errorCallback in dfStartOrchestrator)
      const data = {
        storeId: currentStore?.id,
        orchestrator: orchestratorConstants.UPDATE_INVENTORY_PRESETS,
      };
      dfStartOrchestrator(data, () => {
        setIsDisableResetInventory(false);
      });
      toggleConfirmationModal();
      isNewResetStartedRef.current = true;
    } catch (error) {
      customToast(error, toastType.ERROR);
      toggleConfirmationModal();
    }
  };

  // cancel button handler
  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };
  return (
    <>
      <ButtonWithToolTip
        IconImage={shouldShowSpinner ? LoadingIndicatorCentered : ResetCartIcon}
        handleClick={handleUpdateInventoryPresetsToDefault}
        isDisabled={isResetInventoryButtonDisabled}
        label="Reset Existing Inventory"
        className="w-100 d-flex justify-content-center align-items-center text-center"
        toolTipRootClassName="w-100"
        toolTipBody={
          isResetAllowed
            ? EMPTY_STRING
            : shopifyConstants.COMPANY_RESET_ADMIN_ONLY
        }
      />
      {/* company store non admin only sees the disabled button with the reason */}
      <ButtonWithToolTip
        IconImage={ShowIcon}
        handleClick={toggleResetStatusModal}
        isDisabled={isViewResetStatusButtonDisabled}
        label="View Reset Status"
        className="w-100 d-flex justify-content-center align-items-center text-center"
        toolTipRootClassName="w-100"
        toolTipBody={
          isResetAllowed
            ? EMPTY_STRING
            : shopifyConstants.COMPANY_RESET_ADMIN_ONLY
        }
      />

      <ConfirmationModal
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
        message={`<h5>Confirm Shopify Configuration Reset for All Inventory Items</h5>
            <p>
                This action will replace all existing <strong>Shopify Configuration Settings</strong> for every item in ${
                  isCompanyStore
                    ? "the inventory of every Store in your Company connected to Shopify"
                    : "your Store inventory"
                }. These settings will be replaced according to the current applicable <strong>Global</strong> and <strong>Custom Shopify Configuration</strong> settings for each item.
            </p>

            <p>This includes the following configurations:</p>
            <ul>
                <li>Link to Shopify</li>
                <li>Separate In-Store &amp; Online Quantities</li>
                <li>All Shopify Field Mappings Settings</li>
            </ul>

            <p>While this update is running:</p>
            <ul>
                <li>
                All <strong>inventory-related actions</strong> in CollectPOS (such as Sales, Trades, Returns, Adding or Editing Inventory, etc.) will be temporarily disabled to prevent conflicts.
                </li>
                <li>
                Your connected Shopify Store’s Website will also be temporarily unavailable.
                </li>
                <li>
                No changes or edits should be made directly on Shopify during the update process to avoid interruptions.
                </li>
            </ul>

            <p>
                It is highly recommended to only execute this action outside of business/operating hours. <strong>Are you sure you want to proceed?</strong>
            </p>`}
        yesButtonText="Confirm"
        noButtonText="Cancel"
        isHtmlMessage={true}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  shopify: state.shopify,
  spinnerArray: state.system.spinnerArray,
  currentStore: state.store.currentStore,
  storeMiscData: state.store.storeMiscData,
  draggableNotification: state.system.draggableNotification,
  isDisableResetInventory: state.shopify.isDisableResetInventory,
});

const mapDispatchToProps = (dispatch) => ({
  dfStartOrchestrator: (data, errorCallback) =>
    dispatch(systemActions.dfStartOrchestrator(data, errorCallback)),
  setIsDisableResetInventory: (data) =>
    dispatch(custom(data, shopifyConstants.SET_IS_DISABLE_RESET_INVENTORY)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateInventoryButton);
